'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var reactIntl = require('react-intl');
require('../../../typography/ErrorText/ErrorText.js');
require('../../../typography/LargeDarkText/LargeDarkText.js');
require('../../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../../typography/MediumDarkText/MediumDarkText.js');
require('../../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../../typography/MediumText/MediumText.js');
require('../../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../../typography/MiniatureLinkText/MiniatureLinkText.js');
var SmallDarkText = require('../../../typography/SmallDarkText/SmallDarkText.js');
require('../../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../../typography/SmallLinkText/SmallLinkText.js');
require('../../../typography/SmallTitleText/SmallTitleText.js');
require('../../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../../typography/TinyDarkText/TinyDarkText.js');
require('../../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../../typography/TinyLinkText/TinyLinkText.js');
require('../../../typography/TinyTitleText/TinyTitleText.js');
require('../../../typography/XXLargeDarkText/XXLargeDarkText.js');
var moment = _interopDefault(require('moment'));
var ToggleSwitch = require('../../ToggleSwitch/ToggleSwitch.js');
var TimeInputSelect = require('../../TimeInputSelect/TimeInputSelect.js');
var styledComponents = require('../styled-components.js');

var WeekdayControl = function (props) {
    var day = props.day, dayData = props.dayData, onChange = props.onChange;
    var fm = reactIntl.useIntl().formatMessage;
    var _a = React.useState(dayData), inputData = _a[0], setInputData = _a[1];
    var onInputChange = function (attr, newValue) {
        var _a;
        onChange(day, attr, newValue);
        setInputData(tslib.__assign(tslib.__assign({}, inputData), (_a = {}, _a[attr] = newValue, _a)));
    };
    var step = dayData.increments ? dayData.increments : 3600;
    var fromMaxTime = dayData.to
        ? moment(dayData.to, 'HH:mm')
            .subtract(step, 's')
            .format('HH:mm')
        : '23:00';
    var toMinTime = dayData.from
        ? moment(dayData.from, 'HH:mm')
            .add(step, 's')
            .format('HH:mm')
        : '00:00';
    return (React__default.createElement(styledComponents.WeekdayElement, null,
        React__default.createElement("div", { style: { margin: '0 1rem' } },
            React__default.createElement(ToggleSwitch, { onToggleClick: function (newValue) { return onInputChange('active', newValue); }, initialCheck: dayData.active })),
        React__default.createElement(SmallDarkText, { style: { minWidth: '140px' } }, fm({ id: "componentLib.appWide.weekdays." + day })),
        React__default.createElement("div", { style: { width: '120px', marginRight: '1.5rem' } },
            React__default.createElement(TimeInputSelect, { id: "from-time-select-" + day, onChange: function (selected) {
                    onInputChange('from', selected === null || selected === void 0 ? void 0 : selected.value);
                }, minTime: '00:00', maxTime: fromMaxTime, step: step, disableClearable: true, disabled: !dayData.active, defaultValue: dayData.from ? dayData.from : null, placeholder: fm({ id: "componentLib.activeWeekdayHours.startTime" }) })),
        React__default.createElement("div", { style: { width: '120px' } },
            React__default.createElement(TimeInputSelect, { id: "to-time-select-" + day, onChange: function (selected) {
                    onInputChange('to', selected === null || selected === void 0 ? void 0 : selected.value);
                }, minTime: toMinTime, maxTime: '23:00', step: step, disableClearable: true, disabled: !dayData.active, defaultValue: dayData.to ? dayData.to : null, placeholder: fm({ id: "componentLib.activeWeekdayHours.endTime" }) }))));
};

module.exports = WeekdayControl;
